import { i18n, namespaces } from "@/i18n/index";
import { PropRouteItems } from "@/models/routes/propRouteItems";
import envSettings from "@/services/system/envSettings";

const tNamespace = { ns: namespaces.routes };

export const propertiesRoutes: PropRouteItems = {
  citizenFrontPage: { route: "/", path: envSettings.FRONT_PAGE_CITIZEN, title: i18n.t("main.title") },
  caseworkerFrontPage: { route: "/", path: envSettings.FRONT_PAGE_CASEWORKER, title: i18n.t("main.title") },
  property: {
    route: i18n.t("properties.property.route", tNamespace),
    path: i18n.t("properties.property.path", tNamespace),
    title: i18n.t("property.title"),
  },
  loanApp: {
    route: i18n.t("properties.loanApp.route", tNamespace),
    path: i18n.t("properties.loanApp.path", tNamespace),
    title: i18n.t("loanApp.title"),
    description: i18n.t("loanApp.description"),
  },
  activeLoans: {
    route: i18n.t("properties.activeLoan.route", tNamespace),
    path: i18n.t("properties.activeLoan.path", tNamespace),
    title: i18n.t("loans.active.title"),
    description: i18n.t("loans.active.description"),
  },
  paidLoans: {
    route: i18n.t("properties.paidLoans.route", tNamespace),
    path: i18n.t("properties.paidLoans.path", tNamespace),
    title: i18n.t("loans.paid.title"),
    description: i18n.t("loans.paid.description"),
  },
  consent: {
    route: i18n.t("properties.consent.route", tNamespace),
    path: i18n.t("properties.consent.path", tNamespace),
    title: i18n.t("consent.title"),
    description: i18n.t("consent.description"),
  },
  payment: {
    route: i18n.t("properties.payment.route", tNamespace),
    path: i18n.t("properties.payment.path", tNamespace),
    title: i18n.t("loans.payment.title"),
    description: i18n.t("loans.payment.description"),
  },
};
